/**
 * This method will override ba-sidebar directive to reload menu items each time language changes.
 * @param $delegate
 * @param baSidebarService
 * @returns {*}
 */
/** @ngInject */
function baSidebarDirectiveDecorator($delegate, baSidebarService) {


    $delegate.forEach(sidebarDirectiveDelegate => {
        if (sidebarDirectiveDelegate.link) {
            let oldLink = sidebarDirectiveDelegate.link;
            sidebarDirectiveDelegate.link = function (scope, el) {
                oldLink.apply(this, arguments);

                scope.$on('gettextLanguageChanged', function(){
                    scope.menuItems = baSidebarService.getMenuItems();
                })
            };

            sidebarDirectiveDelegate.compile = function () {
                return sidebarDirectiveDelegate.link;
            };

            sidebarDirectiveDelegate.template = sidebarDirectiveDelegate.template.replace('ng-repeat="item in ::menuItems"', 'ng-repeat="item in menuItems"')
        }
    });

    return $delegate;
}

export default baSidebarDirectiveDecorator


// WEBPACK FOOTER //
// ./src/cmsCore/BlurAdmin/baSidebarDecorator/baSidebarDirectiveDecorator.js